/**
 * DotMapPR — Puerto Rico subclass of DotMap.
 *
 * Sets PR-specific data sources. Phase 5 will add role binding + EPL-specific
 * defaults (campaign theme tokens, Spanish copy, etc).
 *
 * Per stu_plan--epl-dot-map-component-v3.md §1.
 */

import { DotMap } from './dot-map';

export class DotMapPR extends DotMap {
  static defaultGeographySrc = '/widgets/data/pr-outline.svg';
  static defaultDataSrc = '/widgets/data/pr-anchors.json';
  static defaultRolesSrc = '/widgets/data/epl-roles.json';
}

if (!customElements.get('dot-map-pr')) {
  customElements.define('dot-map-pr', DotMapPR);
}
